import React from "react";

import useGetPortfolioPlanById from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanById";
import { PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  portfolioPlanId: PortfolioPlanId;
}

const PlanTitle = ({ portfolioPlanId }: Props) => {
  const advisorAuth = useAdvisorRequestAuth();
  const auth = useRequestAuth();
  const { data, hasError, isLoading } = useGetPortfolioPlanById(
    portfolioPlanId,
    {},
    auth ?? advisorAuth
  );

  if (hasError || isLoading || data === undefined) {
    return <Skeleton width={30} />;
  }

  return <Text>{data.data.plan.name}</Text>;
};

export default PlanTitle;
